<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo_white.png" alt="logo图">
    </div>
    <p class="title">温江区金手指网络技术工作室</p>
    <p class="address_tel_fax">
      <span>地址：四川成都</span> 
    </p>
    <p class="email_wx">
      <span>邮箱：it@goldfe.cn</span>
      <!-- <span>公司微信号：ilyk_gg</span> -->
    </p>
    <p class="copy">Copyright &copy; 2023 - goldfe.cn <a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备2023017110号</a></p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 238px;
  height: 95px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue